import React, { useEffect, useState } from 'react'
import { Btn, CustomModal, InputText } from '../../../../components'

export default function ModalConfirmarExclusaoInventario({
  isVisible,
  onClose,
  onConfirm,
  onError,
  inventario,
}) {
  const [codigo, setCodigo] = useState('')

  useEffect(() => {
    if (!isVisible) setCodigo('')
  }, [isVisible])

  function confirmarExclusao() {
    if (codigo.trim() !== String(inventario.inventario_id)) {
      onError('O código informado não confere com o código do Inventário')
      return
    }
    onConfirm(inventario)
  }

  return (
    <CustomModal
      header="Confirmar Exclusão de Inventário"
      isVisible={isVisible}
      onClose={onClose}
      width="450px"
    >
      <div className="p-grid">
        <div className="p-col-12">
          <p style={{ color: '#D32F2F', fontWeight: 'bold' }}>
            Atenção! Este inventário já está em Conferência, ao apagá-lo todo o progresso será
            perdido! Essa ação é IRREVERSÍVEL!
          </p>
          <p style={{ marginTop: 10 }}>
            Caso realmente deseje apagá-lo, preencha o campo abaixo com o código do Inventário e
            Confirme
          </p>
        </div>
        <div className="p-col-12">
          <InputText
            label="Código do Inventário :"
            marginTop={0}
            placeholder={inventario ? String(inventario.inventario_id) : ''}
            value={codigo}
            onChange={value => setCodigo(value)}
          />
        </div>
        <div className="p-col-12">
          <Btn backgroundColor="#D32F2F" onClick={confirmarExclusao}>
            Confirmar Exclusão
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}
